import { request } from './request';

/**
 * 获取企业导师列表
 */
export function getMentorList() {
  return request.get('/enterprise_mentor/list');
}

/**
 * 根据ID获取企业导师详情
 * @param id - 导师ID
 */
export function getMentorById(id: number) {
  return request.get(`/enterprise_mentor/get/${id}`);
}

/**
 * 技术经理人图片项
 */
export interface TechnicalManagerImage {
  id: number;
  title: string;
  url: string;
  label: string;
  publishTime: string;
  sortOrder: number;
  status: number;
}

/**
 * 技术经理人信息
 */
export interface TechnicalManagerInfo {
  description: string;
  imageList: TechnicalManagerImage[];
}

/**
 * 获取技术经理人信息（简介和图片列表）
 */
export function getTechnicalManagerInfo() {
  return request.get('/technical_manager/info');
}
